
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({

    selector: 'finalizacion',
    templateUrl: './finalizacion.html',
    styleUrls: ['./finalizacion.css']

})

export class FinalizacionComponent implements OnInit {
mobile: any;
verVolver=false
    constructor(
        private router: Router
    ) { }

    ngOnInit(): void {
        let user = JSON.parse(sessionStorage.getItem('access_token'));
        if (user && user.user && user.user.brokerId) {
            this.verVolver=true;
        }
        this.mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        setTimeout(() => {
            this.responsive();
        }, 1000);
    }

    responsive() {
        const elm1 = <HTMLElement>document.getElementById('footerLibertyc');
        const elm2 = <HTMLElement>document.getElementById('ftxt1');
        const elm3 = <HTMLElement>document.getElementById('ftxt2');
        const yearText = <HTMLElement>document.getElementById('yearText');
        if (this.mobile) {
            elm1.style.height = 'auto';
            elm2.style.paddingLeft = '25px';
            elm3.style.paddingRight = '25px';
            elm3.style.marginTop = '10px';
            yearText.style.marginTop = '10px';
        } else {
            elm1.style.height = '190px';
            elm2.style.paddingLeft = '120px';
            elm3.style.paddingRight = '120px';
        }
    }
    volver(){
        this.router.navigate(['tramites']);
    }

}